// HomeWeb.jsx
import React, {useEffect} from 'react';
import { Text, ScrollView, View, Image, TouchableOpacity, Platform } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import BaseWeb from './components/baseWeb';
import styles from './styles/homeWebStyles';
import CardGrid from '../screens/modal/trilhamodalWeb';
import { useLogScreen } from '../useLogScreen';
export default function TrilhaDoConhecimentoWeb() {
    useLogScreen('TrilhaDoConhecimento');
    useEffect(() => {
        if (Platform.OS === 'web') {
            setTimeout(() => {
                document.title = 'imoGo | Trilha do conhecimento';
            }, 100);
        }
    }, []);
    return (
        <BaseWeb>
            {(userInfo) => (
                <ScrollView contentContainerStyle={styles.contentMinimal}>
                    <Text style={styles.title}>Trilha do conhecimento</Text>
                    <View style={styles.zi}>
                        <CardGrid />
                    </View>
                </ScrollView>
            )}
        </BaseWeb>
    );
}
